import { render } from "./PricingView.vue?vue&type=template&id=b4aed32e&scoped=true"
import script from "./PricingView.vue?vue&type=script&lang=js"
export * from "./PricingView.vue?vue&type=script&lang=js"

import "./PricingView.vue?vue&type=style&index=0&id=b4aed32e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4aed32e"]])

export default __exports__